import ToastHighLighter from '@/lib/ToastHighLighter';

export const FormFloatingCode = () => {
  const language = 'html';
  const codeString = `
  // Form floating
  <form noValidate method="" id="bootstrapForm">
    <div className="form-floating mb-3">
      <input
        type="email"
        className="form-control"
        id="floatingInput"
        placeholder="name@example.com"
        required
      />
      <label htmlFor="floatingInput">Email address</label>
      <div className="invalid-feedback">
        You must agree before submitting.
      </div>
    </div>
    <div className="form-floating">
      <input
        type="password"
        className="form-control"
        id="floatingPassword"
        placeholder="Password"
        autoComplete="on"
      />
      <label htmlFor="floatingPassword">Password</label>
    </div>
  </form>
`;

  return (
    <>
      <ToastHighLighter
        name={'formfloating'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
